import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { PlusIcon } from "app/icons";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import {
  QUOTE_EQUIPMENT_TABLE_COLUMNS,
  QUOTE_EQUIPMENT_TABLES,
} from "../../../data";
import { tyingKey, useQuoteAccessories } from "../../../hooks/useQuoteAccessories";
import { quotesActions } from "../../../redux/slice";
import { QuoteAccessoryTableRow } from "../../../types";
import { useStyles } from "../styles";

type Column = keyof typeof QUOTE_EQUIPMENT_TABLE_COLUMNS;

const cellValue = (value: string, t: (key: string) => string) =>
  value.startsWith("QUOTES.") ? t(value) : value;

const AccessoriesTable = () => {
  const { t } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();
  const data = useQuoteAccessories();

  return (
    <Box className={styles.tablesWrapper}>
      {QUOTE_EQUIPMENT_TABLES.map((table) => {
        const isToolbox = table.variant === "toolbox";
        const headClass = isToolbox
          ? styles.tableHeadRow
          : styles.tableHeadRowBasket;
        const bodyClass = isToolbox
          ? styles.tableBodyRow
          : styles.tableBodyRowBasket;

        return (
          <Box key={table.tableKey} className={styles.tableBlock}>
            <Box className={styles.tableHeaderRow}>
              <Typography className={styles.tableTitle}>
                {t(table.titleKey)}
              </Typography>
              <Button
                className={styles.addRowButton}
                variant="contained"
                color="primary"
                startIcon={<PlusIcon width={20} height={20} />}
                onClick={() =>
                  dispatch(
                    quotesActions.addAccessoryTableRow(table.tableKey)
                  )
                }
              >
                {t(tyingKey("TABLES.ADD_ROW"))}
              </Button>
            </Box>
            <Box className={styles.table}>
              <Box className={headClass}>
                <Typography className={styles.tableHeadCell}>#</Typography>
                {table.columns.map((column) => (
                  <Typography key={column} className={styles.tableHeadCell}>
                    {t(QUOTE_EQUIPMENT_TABLE_COLUMNS[column as Column])}
                  </Typography>
                ))}
              </Box>
              {data.tables[table.tableKey].map(
                (row: QuoteAccessoryTableRow, index: number) => (
                  <Box key={row.id} className={bodyClass}>
                    <Box
                      className={`${styles.tableCell} ${styles.tableIndexCell}`}
                    >
                      {index + 1}
                    </Box>
                    {table.columns.map((column) => (
                      <Box
                        key={`${row.id}-${column}`}
                        className={styles.tableCell}
                      >
                        <Typography className={styles.tableCellText}>
                          {cellValue(row[column as Column], t)}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                )
              )}
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default AccessoriesTable;
